import { Action } from '@ngrx/store';
import { Amenity } from '@shared/models/amenity.model';
import { CarSearchResult } from '@shared/models/car-search-response.model';
import { DiningFilters } from '@shared/models/filter.model';
import { InternationalRegion } from '@shared/models/international-region.model';
import { IFilterTags } from '@shared/models/tag';
import { TravelCarHireFilterForm } from '@shared/shared/interfaces/travel-car-hire.interfaces';

export const GET_STATE_DINING_FILTERS = '[Filters] Get State Dining Filters';
export const GET_DINING_FILTERS = '[Filters] Get Dining Filters';
export const GET_DINING_FILTERS_SUCCESS = '[Filters] Get Dining Filters Success';

export const GET_MEMBER_EVENT_FILTERS = '[Filters] Get Member Event Filters';
export const GET_MEMBER_EVENT_FILTERS_SUCCESS = '[Filters] Get Member Event Filters Success';

export const GET_ENTERTAINMENT_FILTERS = '[Filters] Get Entertainment Filters';
export const GET_ENTERTAINMENT_FILTERS_SUCCESS = '[Filters] Get Entertainment Filters Success';

export const GET_MEMBER_BENEFITS_FILTERS = '[Filters] Get Member Benefits Filters';
export const GET_MEMBER_BENEFITS_FILTERS_SUCCESS = '[Filters] Get Member Benefits Filters Success';

export const GET_HOTEL_FILTERS = '[Filters] Get Hotel Filters';
export const GET_HOTEL_FILTERS_SUCCESS = '[Filters] Get Hotel Filters Success';

export const GET_FLIGHT_FILTERS = '[Filters] Get Flight Filters';
export const GET_FLIGHT_FILTERS_SUCCESS = '[Filters] Get Flight Filters Success';

export const GET_CAR_FILTERS = '[Filters] Get Car Filters';
export const GET_CAR_FILTERS_SUCCESS = '[Filters] Get Car Filters Success';

export const GET_ARTICLE_FILTERS = '[Filters] Get Article Filters';
export const GET_ARTICLE_FILTERS_SUCCESS = '[Filters] Get Article Filters Success';

export const GET_INSPIRATION_FILTERS = '[Filters] Get Inspiration Filters';
export const GET_INSPIRATION_FILTERS_SUCCESS = '[Filters] Get Inspiration Filters Success';

export const GET_PREFERENCES_FILTERS = '[Filters] Get Preferences Filters';
export const GET_PREFERENCES_FILTERS_SUCCESS = '[Filters] Get Preferences Filters Success';

export class GetStateDiningFilters implements Action {
  readonly type = GET_STATE_DINING_FILTERS;
}
export class GetDiningFilters implements Action {
  readonly type = GET_DINING_FILTERS;
  constructor(public payload: number[] = []) {}
}

export class GetDiningFiltersSuccess implements Action {
  readonly type = GET_DINING_FILTERS_SUCCESS;
  constructor(
    public payload: {
      cuisines: DiningFilters[];
      tags: DiningFilters[];
      memberBenefits: DiningFilters[];
      esg_tags: DiningFilters[];
    }
  ) {}
}

export class GetMemberEventFilters implements Action {
  readonly type = GET_MEMBER_EVENT_FILTERS;
}

export class GetMemberEventFiltersSuccess implements Action {
  readonly type = GET_MEMBER_EVENT_FILTERS_SUCCESS;
  constructor(public payload: Array<any>) {}
}

export class GetEntertainmentFilters implements Action {
  readonly type = GET_ENTERTAINMENT_FILTERS;
}

export class GetEntertainmentFiltersSuccess implements Action {
  readonly type = GET_ENTERTAINMENT_FILTERS_SUCCESS;
  constructor(public payload: Array<any>) {}
}

export class GetMemberBenefitsFilters implements Action {
  readonly type = GET_MEMBER_BENEFITS_FILTERS;
}

export class GetMemberBenefitsFiltersSuccess implements Action {
  readonly type = GET_MEMBER_BENEFITS_FILTERS_SUCCESS;
  constructor(public payload: Array<any>) {}
}

export class GetHotelFilters implements Action {
  readonly type = GET_HOTEL_FILTERS;
}

export class GetHotelFiltersSuccess implements Action {
  readonly type = GET_HOTEL_FILTERS_SUCCESS;
  constructor(public payload: { amenities: Array<Amenity>; starRatings: Array<any> }) {}
}

export class GetFlightFilters implements Action {
  readonly type = GET_FLIGHT_FILTERS;
  constructor(public payload: any) {}
}

export class GetFlightFiltersSuccess implements Action {
  readonly type = GET_FLIGHT_FILTERS_SUCCESS;
  constructor(public payload: { airlines: Array<any>; departure: Array<any>; return: any[] }) {}
}

export class GetCarFilters implements Action {
  readonly type = GET_CAR_FILTERS;
  constructor(
    public payload: { car_type: Array<any>; supplier: Array<any>; pax_capacity: Array<any> },
    public currentFilters: Partial<TravelCarHireFilterForm>,
    public visibleCars: CarSearchResult[],
    public allCars: CarSearchResult[]
  ) {}
}

export class GetCarFiltersSuccess implements Action {
  readonly type = GET_CAR_FILTERS_SUCCESS;
  constructor(
    public payload: {
      pax_capacity: Array<any>;
      supplier: Array<any>;
      car_type: Array<any>;
      instalment_payment_available: boolean;
    }
  ) {}
}

export class GetArticleFilters implements Action {
  readonly type = GET_ARTICLE_FILTERS;
}

export class GetArticleFiltersSuccess implements Action {
  readonly type = GET_ARTICLE_FILTERS_SUCCESS;
  constructor(public payload: Array<IFilterTags>) {}
}

export class GetInspirationFilters implements Action {
  readonly type = GET_INSPIRATION_FILTERS;
  constructor(public payload: { inspiration_format?: number; inspiration_destinations?: boolean }) {}
}

export class GetInspirationFiltersSuccess implements Action {
  readonly type = GET_INSPIRATION_FILTERS_SUCCESS;
  constructor(public payload: { category: Array<IFilterTags>; destination: Array<InternationalRegion> }) {}
}

export class GetPrefrencesFilters implements Action {
  readonly type = GET_PREFERENCES_FILTERS;
}

export class GetPrefrencesFiltersSuccess implements Action {
  readonly type = GET_PREFERENCES_FILTERS_SUCCESS;
  constructor(public payload: Array<any>) {}
}

export type FiltersAction =
  | GetStateDiningFilters
  | GetDiningFilters
  | GetDiningFiltersSuccess
  | GetMemberEventFilters
  | GetMemberEventFiltersSuccess
  | GetEntertainmentFilters
  | GetEntertainmentFiltersSuccess
  | GetMemberBenefitsFilters
  | GetMemberBenefitsFiltersSuccess
  | GetHotelFilters
  | GetHotelFiltersSuccess
  | GetFlightFilters
  | GetFlightFiltersSuccess
  | GetCarFilters
  | GetCarFiltersSuccess
  | GetArticleFilters
  | GetArticleFiltersSuccess
  | GetInspirationFilters
  | GetInspirationFiltersSuccess
  | GetPrefrencesFilters
  | GetPrefrencesFiltersSuccess;
